/**
 * The supported-formats list from GET /documents/supported-formats (built
 * server-side from the registered file processors).
 */

import { useEffect, useState } from 'react';
import { documentsApi, type SupportedFormatsResponse } from '../lib/api';

// The list only changes on deploy: fetch it once per page load and share it
// between every dialog that shows it.
let formatsRequest: Promise<SupportedFormatsResponse> | null = null;

function loadSupportedFormats(): Promise<SupportedFormatsResponse> {
  if (!formatsRequest) {
    formatsRequest = documentsApi.getSupportedFormats().catch((err) => {
      formatsRequest = null; // let the next dialog retry
      throw err;
    });
  }
  return formatsRequest;
}

/** Test hook: forget the cached list. */
export function resetSupportedFormatsCache(): void {
  formatsRequest = null;
}

export function useSupportedFormats(): SupportedFormatsResponse | null {
  const [formats, setFormats] = useState<SupportedFormatsResponse | null>(null);
  useEffect(() => {
    let cancelled = false;
    loadSupportedFormats()
      .then((data) => {
        if (!cancelled) setFormats(data);
      })
      .catch(() => {
        // Without the list the drop zone still works; the hint just stays short.
      });
    return () => {
      cancelled = true;
    };
  }, []);
  return formats;
}
